<template>
  <figure v-appear="{ threshold, handler: onVisible }" class="brand-graphic">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1919 1016.8" class="brand-graphic__vector">
      <path
        v-for="{ totalTime, ...attributes } in strokes"
        :key="totalTime"
        ref="stroke"
        v-bind="attributes"
        class="brand-graphic__path"
        fill="none"
        stroke-width="50"
        stroke="rgb(26,69,169)"
        stroke-linejoin="round"
        stroke-linecap="round"
        stroke-miterlimit="4"
      />
    </svg>

    <div
      v-for="{ number, text, ...attributes } in bullets"
      :key="number"
      v-bind="attributes"
      class="brand-graphic__bullet"
    >
      <div class="brand-graphic__content">
        <p class="brand-graphic__number">{{ number }}</p>
        <p class="brand-graphic__text">{{ text }}</p>
      </div>
    </div>
  </figure>
</template>

<script>
export default {
  name: 'BrandGraphic',
  data() {
    return {
      totalDuration: 2000,
      isVisible: false,
      totalLength: 1,
      strokeAttributes: [
        { d: 'M 39 410 Q 181 266 181 266 L 308.263 465.739', length: 0 },
        { d: 'M 309.048 466.971 L 476 729 L 578 236 L 728.211 551.855', length: 0 },
        { d: 'M 736.208 568.671 L 870 850 L 1164.895 460.283', length: 0 },
        { d: 'M 1181 439 L 1492 28 L 1591.26 551.722', length: 0 },
        { d: 'M 1594.927 571.068 L 1673 983 L 1882 696', length: 0 }
      ],
      bulletAttributes: [
        { coordinates: { '--x': '16%', '--y': '45%' } },
        { coordinates: { '--x': '38%', '--y': '54%' } },
        { coordinates: { '--x': '60%', '--y': '45%' } },
        { coordinates: { '--x': '82%', '--y': '54%' } }
      ]
    }
  },
  computed: {
    strokes() {
      let cumulative = 0

      return this.strokeAttributes.map(({ d, length }, index) => {
        const relativeLength = Math.round((length / this.totalLength) * 100) / 100
        const duration = this.totalDuration * relativeLength
        const delay = cumulative
        cumulative += duration

        return {
          d,
          totalTime: duration + delay || index,
          class: { '-play': this.isVisible },
          style: { '--array': length, '--duration': `${duration}ms`, '--delay': `${delay}ms` }
        }
      })
    },
    bullets() {
      return this.bulletAttributes.map(({ coordinates }, index) => {
        const delay = this.strokes[index].totalTime - 150

        return {
          number: this.formatNumber(this.$t('home.bullets')[index].number),
          text: this.$t('home.bullets')[index].label,
          class: { '-play': this.isVisible },
          style: {
            ...coordinates,
            '--delay-outer': `${delay}ms`,
            '--delay-inner': `${delay + 50}ms`,
            '--delay-number': `${delay + 425}ms`,
            '--delay-text': `${delay + 475}ms`
          }
        }
      })
    },
    threshold() {
      return this.$device.tablet ? 0.5 : 0.25
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (!this.$refs.stroke || !this.$refs.stroke.length) return

      this.$refs.stroke.forEach((stroke, index) => {
        this.strokeAttributes[index].length = stroke.getTotalLength() + 1
      })

      this.totalLength = this.strokeAttributes.reduce((acc, { length }) => acc + length, 0)
    })
  },
  methods: {
    onVisible() {
      this.isVisible = true
    },
    formatNumber(number) {
      return number.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
    }
  }
}
</script>
